// src/admin/models/ApplicationDocumentTypeEnum.ts
var ApplicationDocumentTypeEnum = /* @__PURE__ */ ((ApplicationDocumentTypeEnum2) => {
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["None"] = 0] = "None";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["Unknown"] = 1] = "Unknown";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ContractWithAgent"] = 10] = "ContractWithAgent";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["PaymentOrder"] = 20] = "PaymentOrder";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ContractWithCounterparty"] = 30] = "ContractWithCounterparty";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["DeliveryDocuments"] = 40] = "DeliveryDocuments";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ServiceAgreement"] = 50] = "ServiceAgreement";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["DocumentsOnExecuting"] = 60] = "DocumentsOnExecuting";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["OtherDocuments"] = 70] = "OtherDocuments";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ExchangeAgreement"] = 80] = "ExchangeAgreement";
  return ApplicationDocumentTypeEnum2;
})(ApplicationDocumentTypeEnum || {});

// src/admin/models/CountryEnum.ts
var CountryEnum = /* @__PURE__ */ ((CountryEnum2) => {
  CountryEnum2[CountryEnum2["None"] = 0] = "None";
  CountryEnum2[CountryEnum2["Russia"] = 1] = "Russia";
  CountryEnum2[CountryEnum2["China"] = 10] = "China";
  CountryEnum2[CountryEnum2["USA"] = 20] = "USA";
  CountryEnum2[CountryEnum2["Italy"] = 30] = "Italy";
  return CountryEnum2;
})(CountryEnum || {});

// src/admin/models/CryptoCurrencyEnum.ts
var CryptoCurrencyEnum = /* @__PURE__ */ ((CryptoCurrencyEnum2) => {
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["None"] = 0] = "None";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["ETH"] = 10] = "ETH";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["USDC"] = 20] = "USDC";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["USDT"] = 30] = "USDT";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["BTC"] = 40] = "BTC";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["BNB"] = 50] = "BNB";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["TON"] = 60] = "TON";
  return CryptoCurrencyEnum2;
})(CryptoCurrencyEnum || {});

// src/admin/models/EpochEnum.ts
var EpochEnum = /* @__PURE__ */ ((EpochEnum2) => {
  EpochEnum2[EpochEnum2["All"] = 1] = "All";
  EpochEnum2[EpochEnum2["Draft"] = 2] = "Draft";
  EpochEnum2[EpochEnum2["New"] = 3] = "New";
  EpochEnum2[EpochEnum2["Review"] = 100] = "Review";
  EpochEnum2[EpochEnum2["ReviewAdmin"] = 101] = "ReviewAdmin";
  EpochEnum2[EpochEnum2["ReviewBank"] = 102] = "ReviewBank";
  EpochEnum2[EpochEnum2["ChangesRequired"] = 200] = "ChangesRequired";
  EpochEnum2[EpochEnum2["Confirmed"] = 300] = "Confirmed";
  EpochEnum2[EpochEnum2["ConfirmedAdmin"] = 301] = "ConfirmedAdmin";
  EpochEnum2[EpochEnum2["ExpectConfirmation"] = 302] = "ExpectConfirmation";
  EpochEnum2[EpochEnum2["ExpectingSigning"] = 303] = "ExpectingSigning";
  EpochEnum2[EpochEnum2["ExpectingPayment"] = 304] = "ExpectingPayment";
  EpochEnum2[EpochEnum2["InProgress"] = 400] = "InProgress";
  EpochEnum2[EpochEnum2["ReceiptOfMoney"] = 401] = "ReceiptOfMoney";
  EpochEnum2[EpochEnum2["Completed"] = 500] = "Completed";
  EpochEnum2[EpochEnum2["Accomplished"] = 600] = "Accomplished";
  EpochEnum2[EpochEnum2["Blocked"] = -200] = "Blocked";
  EpochEnum2[EpochEnum2["Refusal"] = -101] = "Refusal";
  EpochEnum2[EpochEnum2["Rejected"] = -100] = "Rejected";
  return EpochEnum2;
})(EpochEnum || {});

// src/admin/models/OrganizationDocumentTypeEnum.ts
var OrganizationDocumentTypeEnum = /* @__PURE__ */ ((OrganizationDocumentTypeEnum2) => {
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["Unknown"] = 1] = "Unknown";
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["EGRUL"] = 10] = "EGRUL";
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["Proxy"] = 20] = "Proxy";
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["CharterOfEnterprise"] = 30] = "CharterOfEnterprise";
  return OrganizationDocumentTypeEnum2;
})(OrganizationDocumentTypeEnum || {});

// src/admin/models/OrganizationStatusEnum.ts
var OrganizationStatusEnum = /* @__PURE__ */ ((OrganizationStatusEnum2) => {
  OrganizationStatusEnum2[OrganizationStatusEnum2["Awaiting\u0421onfirmation"] = 0] = "Awaiting\u0421onfirmation";
  OrganizationStatusEnum2[OrganizationStatusEnum2["ExpectsChanges"] = 1] = "ExpectsChanges";
  OrganizationStatusEnum2[OrganizationStatusEnum2["Confirmed"] = 10] = "Confirmed";
  OrganizationStatusEnum2[OrganizationStatusEnum2["Blocked"] = -1] = "Blocked";
  return OrganizationStatusEnum2;
})(OrganizationStatusEnum || {});

// src/admin/models/RoleEnum.ts
var RoleEnum = /* @__PURE__ */ ((RoleEnum2) => {
  RoleEnum2[RoleEnum2["Provider"] = 10] = "Provider";
  RoleEnum2[RoleEnum2["Client"] = 20] = "Client";
  RoleEnum2[RoleEnum2["Admin"] = 30] = "Admin";
  RoleEnum2[RoleEnum2["Bank"] = 40] = "Bank";
  return RoleEnum2;
})(RoleEnum || {});

// src/admin/models/TicketCategoryEnum.ts
var TicketCategoryEnum = /* @__PURE__ */ ((TicketCategoryEnum2) => {
  TicketCategoryEnum2[TicketCategoryEnum2["ProblemWithApplication"] = 10] = "ProblemWithApplication";
  TicketCategoryEnum2[TicketCategoryEnum2["QuestionAboutContract"] = 20] = "QuestionAboutContract";
  TicketCategoryEnum2[TicketCategoryEnum2["TechnicalError"] = 30] = "TechnicalError";
  TicketCategoryEnum2[TicketCategoryEnum2["QuestionAbouDocuments"] = 40] = "QuestionAbouDocuments";
  TicketCategoryEnum2[TicketCategoryEnum2["Other"] = 50] = "Other";
  return TicketCategoryEnum2;
})(TicketCategoryEnum || {});

// src/admin/models/TicketStatusEnum.ts
var TicketStatusEnum = /* @__PURE__ */ ((TicketStatusEnum2) => {
  TicketStatusEnum2[TicketStatusEnum2["Open"] = 10] = "Open";
  TicketStatusEnum2[TicketStatusEnum2["InProgress"] = 20] = "InProgress";
  TicketStatusEnum2[TicketStatusEnum2["Closed"] = 30] = "Closed";
  return TicketStatusEnum2;
})(TicketStatusEnum || {});

// src/admin/models/UserStatusEnum.ts
var UserStatusEnum = /* @__PURE__ */ ((UserStatusEnum2) => {
  UserStatusEnum2[UserStatusEnum2["Awaiting\u0421onfirmation"] = 0] = "Awaiting\u0421onfirmation";
  UserStatusEnum2[UserStatusEnum2["ExpectsChanges"] = 1] = "ExpectsChanges";
  UserStatusEnum2[UserStatusEnum2["Confirmed"] = 10] = "Confirmed";
  UserStatusEnum2[UserStatusEnum2["Blocked"] = -1] = "Blocked";
  return UserStatusEnum2;
})(UserStatusEnum || {});

// src/shared/core/OpenAPI.ts
var OpenAPI = {
  BASE: "",
  VERSION: "1.0",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: async () => {
    const tokenString = localStorage.getItem("token");
    if (tokenString) {
      const tokenResponse = JSON.parse(tokenString);
      return tokenResponse?.accessToken || "";
    }
    return "";
  }
};

// src/shared/core/ApiError.ts
var ApiError = class extends Error {
  url;
  status;
  statusText;
  body;
  request;
  constructor(request2, response, message) {
    super(message);
    this.name = "ApiError";
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
    this.body = response.body;
    this.request = request2;
  }
};

// src/shared/core/CancelablePromise.ts
var CancelError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CancelError";
  }
  get isCancelled() {
    return true;
  }
};
var CancelablePromise = class {
  #isResolved;
  #isRejected;
  #isCancelled;
  #cancelHandlers;
  #promise;
  #resolve;
  #reject;
  constructor(executor) {
    this.#isResolved = false;
    this.#isRejected = false;
    this.#isCancelled = false;
    this.#cancelHandlers = [];
    this.#promise = new Promise((resolve2, reject) => {
      this.#resolve = resolve2;
      this.#reject = reject;
      const onResolve = (value) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#isResolved = true;
        if (this.#resolve)
          this.#resolve(value);
      };
      const onReject = (reason) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#isRejected = true;
        if (this.#reject)
          this.#reject(reason);
      };
      const onCancel = (cancelHandler) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#cancelHandlers.push(cancelHandler);
      };
      Object.defineProperty(onCancel, "isResolved", {
        get: () => this.#isResolved
      });
      Object.defineProperty(onCancel, "isRejected", {
        get: () => this.#isRejected
      });
      Object.defineProperty(onCancel, "isCancelled", {
        get: () => this.#isCancelled
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  get [Symbol.toStringTag]() {
    return "Cancellable Promise";
  }
  then(onFulfilled, onRejected) {
    return this.#promise.then(onFulfilled, onRejected);
  }
  catch(onRejected) {
    return this.#promise.catch(onRejected);
  }
  finally(onFinally) {
    return this.#promise.finally(onFinally);
  }
  cancel() {
    if (this.#isResolved || this.#isRejected || this.#isCancelled) {
      return;
    }
    this.#isCancelled = true;
    if (this.#cancelHandlers.length) {
      try {
        for (const cancelHandler of this.#cancelHandlers) {
          cancelHandler();
        }
      } catch (error) {
        console.warn("Cancellation threw an error", error);
        return;
      }
    }
    this.#cancelHandlers.length = 0;
    if (this.#reject)
      this.#reject(new CancelError("Request aborted"));
  }
  get isCancelled() {
    return this.#isCancelled;
  }
};

// src/shared/core/request.ts
var isDefined = (value) => {
  return value !== void 0 && value !== null;
};
var isString = (value) => {
  return typeof value === "string";
};
var isStringWithValue = (value) => {
  return isString(value) && value !== "";
};
var isBlob = (value) => {
  return typeof value === "object" && typeof value.type === "string" && typeof value.stream === "function" && typeof value.arrayBuffer === "function" && typeof value.constructor === "function" && typeof value.constructor.name === "string" && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
var isFormData = (value) => {
  return value instanceof FormData;
};
var getQueryString = (params) => {
  const qs = [];
  const append = (key, value) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process = (key, value) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          process(key, v);
        });
      } else if (typeof value === "object") {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };
  Object.entries(params).forEach(([key, value]) => {
    process(key, value);
  });
  if (qs.length > 0) {
    return `?${qs.join("&")}`;
  }
  return "";
};
var getUrl = (config, options) => {
  const path = options.url.replace("{api-version}", config.VERSION).replace(/{(.*?)}/g, (substring, group) => {
    if (options.path?.hasOwnProperty(group)) {
      return encodeURI(String(options.path[group]));
    }
    return substring;
  });
  const url = `${config.BASE}${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};
var getFormData = (options) => {
  if (options.formData) {
    const formData = new FormData();
    const process = (key, value) => {
      if (isString(value) || isBlob(value)) {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    };
    Object.entries(options.formData).filter(([_, value]) => isDefined(value)).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => process(key, v));
      } else {
        process(key, value);
      }
    });
    return formData;
  }
  return void 0;
};
var resolve = async (options, resolver) => {
  if (typeof resolver === "function") {
    return resolver(options);
  }
  return resolver;
};
var getHeaders = async (config, options) => {
  const token = await resolve(options, config.TOKEN);
  const headers = Object.entries({
    Accept: "application/json",
    ...options.headers
  }).filter(([_, value]) => isDefined(value)).reduce(
    (headers2, [key, value]) => ({
      ...headers2,
      [key]: String(value)
    }),
    {}
  );
  if (isStringWithValue(token)) {
    headers["X-Access-Token"] = `${token}`;
  }
  if (options.body !== void 0) {
    if (options.mediaType) {
      headers["Content-Type"] = options.mediaType;
    } else if (isBlob(options.body)) {
      headers["Content-Type"] = options.body.type || "application/octet-stream";
    } else if (isString(options.body)) {
      headers["Content-Type"] = "text/plain";
    } else if (!isFormData(options.body)) {
      headers["Content-Type"] = "application/json";
    }
  }
  return new Headers(headers);
};
var getRequestBody = (options) => {
  if (options.body !== void 0) {
    if (options.mediaType?.includes("/json")) {
      return JSON.stringify(options.body);
    } else if (isString(options.body) || isBlob(options.body) || isFormData(options.body)) {
      return options.body;
    } else {
      return JSON.stringify(options.body);
    }
  }
  return void 0;
};
var sendRequest = async (config, options, url, body, formData, headers, onCancel) => {
  const controller = new AbortController();
  const request2 = {
    headers,
    body: body ?? formData,
    method: options.method,
    signal: controller.signal
  };
  if (config.WITH_CREDENTIALS) {
    request2.credentials = config.CREDENTIALS;
  }
  onCancel(() => controller.abort());
  return await fetch(url, request2);
};
var getResponseHeader = (response, responseHeader) => {
  if (responseHeader) {
    const content = response.headers.get(responseHeader);
    if (isString(content)) {
      return content;
    }
  }
  return void 0;
};
var getResponseBody = async (response) => {
  if (response.status !== 204) {
    try {
      const contentType = response.headers.get("Content-Type");
      if (contentType) {
        const jsonTypes = ["application/json", "application/problem+json"];
        const binaryTypes = [
          "application/octet-stream",
          "application/pdf",
          "image/",
          "audio/",
          "video/"
        ];
        const isJSON = jsonTypes.some(
          (type) => contentType.toLowerCase().startsWith(type)
        );
        const isBinary = binaryTypes.some(
          (type) => contentType.toLowerCase().startsWith(type)
        );
        if (isJSON) {
          return await response.json();
        } else if (isBinary) {
          return await response.blob();
        } else {
          return await response.text();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  return void 0;
};
var isResponseDataError = (body) => {
  return typeof body === "object" && body !== null && ("errorCode" in body || "isSuccess" in body);
};
var checkResponseDataError = (options, result) => {
  if (result.status === 200 && result.body && isResponseDataError(result.body)) {
    const { errorCode, isSuccess, errorText } = result.body;
    if (isSuccess === false || errorCode !== null && errorCode !== void 0 && errorCode !== 200) {
      const errorStatus = errorCode ?? 500;
      const errorMessage = errorText || "Unknown error";
      return {
        ...result,
        ok: false,
        status: errorStatus,
        statusText: errorMessage
      };
    }
  }
  return null;
};
var catchErrorCodes = (config, options, result) => {
  const dataErrorResult = checkResponseDataError(options, result);
  const finalResult = dataErrorResult || result;
  const errors = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...options.errors
  };
  const error = errors[finalResult.status];
  if (error) {
    const errorText = typeof finalResult.body === "object" && finalResult.body !== null && "errorText" in finalResult.body ? String(finalResult.body.errorText) : error;
    const apiError = new ApiError(options, finalResult, errorText);
    if (config.ON_ERROR && config.ERROR_ROUTES) {
      const errorRoute = config.ERROR_ROUTES[finalResult.status];
      if (errorRoute) {
        config.ON_ERROR(finalResult.status, errorText);
        return;
      }
    }
    throw apiError;
  }
  if (!finalResult.ok) {
    const errorStatus = finalResult.status ?? "unknown";
    const errorStatusText = finalResult.statusText ?? "unknown";
    const errorBody = (() => {
      try {
        return JSON.stringify(finalResult.body, null, 2);
      } catch (e) {
        return void 0;
      }
    })();
    const errorMessage = `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`;
    const apiError = new ApiError(options, finalResult, errorMessage);
    if (config.ON_ERROR && config.ERROR_ROUTES && typeof errorStatus === "number") {
      const errorRoute = config.ERROR_ROUTES[errorStatus];
      if (errorRoute) {
        config.ON_ERROR(errorStatus, errorMessage);
        return;
      }
    }
    throw apiError;
  }
};
var request = (config, options) => {
  return new CancelablePromise(async (resolve2, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const formData = getFormData(options);
      const body = getRequestBody(options);
      const headers = await getHeaders(config, options);
      if (!onCancel.isCancelled) {
        const response = await sendRequest(
          config,
          options,
          url,
          body,
          formData,
          headers,
          onCancel
        );
        const responseBody = await getResponseBody(response);
        const responseHeader = getResponseHeader(
          response,
          options.responseHeader
        );
        const result = {
          url,
          ok: response.ok,
          status: response.status,
          statusText: response.statusText,
          body: responseHeader ?? responseBody
        };
        catchErrorCodes(config, options, result);
        resolve2(result.body);
      }
    } catch (error) {
      reject(error);
    }
  });
};

// src/admin/services/ApplicationService.ts
var ApplicationService = class {
  /**
   * Получить список заявок
   * @returns ResponseData_PagedResponse_ApplicationListResponse OK
   * @throws ApiError
   */
  static getApiAdminV1Application({
    isAccomplished,
    search,
    epoches,
    currencyId,
    currencyMinAmount,
    currencyMaxAmount,
    cryptoCurrencyId,
    cryptoCurrencyMinAmount,
    cryptoCurrencyMaxAmount,
    minCreateAt,
    maxCreateAt,
    minUpdateAt,
    maxUpdateAt,
    sorts,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/application",
      query: {
        "isAccomplished": isAccomplished,
        "search": search,
        "epoches": epoches,
        "currencyId": currencyId,
        "currencyMinAmount": currencyMinAmount,
        "currencyMaxAmount": currencyMaxAmount,
        "cryptoCurrencyId": cryptoCurrencyId,
        "cryptoCurrencyMinAmount": cryptoCurrencyMinAmount,
        "cryptoCurrencyMaxAmount": cryptoCurrencyMaxAmount,
        "minCreateAt": minCreateAt,
        "maxCreateAt": maxCreateAt,
        "minUpdateAt": minUpdateAt,
        "maxUpdateAt": maxUpdateAt,
        "sorts": sorts,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить заявку
   * @returns ResponseData_ApplicationResponse OK
   * @throws ApiError
   */
  static getApiAdminV1Application1({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/application/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить список документов
   * @returns ResponseData_Array_ApplicationDocumentListResponse OK
   * @throws ApiError
   */
  static getApiAdminV1ApplicationDocument({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/application/{id}/document",
      path: {
        "id": id
      }
    });
  }
  /**
   * Скачать документ
   * @returns binary OK
   * @throws ApiError
   */
  static getApiAdminV1ApplicationDocument1({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/application/document/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Скачать все документы заявки
   * @returns ResponseData_FileStreamResult OK
   * @throws ApiError
   */
  static getApiAdminV1ApplicationDocumentAll({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/application/{id}/document/all",
      path: {
        "id": id
      }
    });
  }
};

// src/admin/services/AuthorizeService.ts
var AuthorizeService = class {
  /**
   * Получить секретный ключ для авторизации по ЭЦП.
   * @returns ResponseData_AuthSecretResponse OK
   * @throws ApiError
   */
  static postApiAdminV1AuthorizeSecret({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/authorize/secret",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить JWT токен
   * @returns ResponseData_AuthTokenResponse OK
   * @throws ApiError
   */
  static postApiAdminV1AuthorizeToken({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/authorize/token",
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/admin/services/DictionaryService.ts
var DictionaryService = class {
  /**
   * Получить список эпох
   * @returns ResponseData_Array_DictionaryEnumResponse_EpochEnum OK
   * @throws ApiError
   */
  static getApiAdminV1DictionaryEpoch({
    isAccomplished
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/dictionary/epoch",
      query: {
        "isAccomplished": isAccomplished
      }
    });
  }
};

// src/admin/services/HundlerService.ts
var HundlerService = class {
  /**
   * Получить список очередей
   * @returns ResponseData_List_QueueHundlerResponse OK
   * @throws ApiError
   */
  static getApiAdminV1HundlerQueueList() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/hundler/queue/list"
    });
  }
  /**
   * Выполнить обработчик
   * @returns any OK
   * @throws ApiError
   */
  static getApiAdminV1HundlerRun({
    stepId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/hundler/run",
      query: {
        "stepId": stepId
      }
    });
  }
};

// src/admin/services/OrganizationService.ts
var OrganizationService = class {
  /**
   * Получить данные организации текущего пользователя
   * @returns ResponseData_OrganizationResponse OK
   * @throws ApiError
   */
  static getApiAdminV1Organization() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/organization"
    });
  }
  /**
   * Обновить данные организации текущего пользователя
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1Organization({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/organization",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Скачать документ
   * @returns binary OK
   * @throws ApiError
   */
  static getApiAdminV1OrganizationFiles({
    fileId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/organization/files/{fileId}",
      path: {
        "fileId": fileId
      }
    });
  }
  /**
   * Получить список документов организации текущего пользователя
   * @returns ResponseData_Array_OrganizationDocumentResponse OK
   * @throws ApiError
   */
  static getApiAdminV1OrganizationFiles1({
    documentTypeIds,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/organization/files",
      query: {
        "documentTypeIds": documentTypeIds,
        "dateFrom": dateFrom,
        "dateTo": dateTo,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Загрузить документы
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1OrganizationFilesUpload({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/organization/files/upload",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Заменить файл
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1OrganizationFilesReplace({
    fileId,
    formData
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/organization/files/{fileId}/replace",
      path: {
        "fileId": fileId
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Переименовать файл
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1OrganizationFilesRename({
    fileId,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/organization/files/{fileId}/rename",
      path: {
        "fileId": fileId
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить тип файла
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1OrganizationFilesSetDocumentType({
    fileId,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/organization/files/{fileId}/setDocumentType",
      path: {
        "fileId": fileId
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить организацияя ожидающие подтверждения
   * @returns ResponseData_Array_ActivationPendingOrganizationResponse OK
   * @throws ApiError
   */
  static getApiAdminV1OrganizationPending() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/organization/pending"
    });
  }
  /**
   * Активировать организацию
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1OrganizationActivate({
    id
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/organization/{id}/activate",
      path: {
        "id": id
      }
    });
  }
  /**
   * Нужны правки по организации
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1OrganizationRework({
    id,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/organization/{id}/rework",
      path: {
        "id": id
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/admin/services/SupportService.ts
var SupportService = class {
  /**
   * Получить обращение
   * @returns ResponseData_TicketResponse OK
   * @throws ApiError
   */
  static getApiAdminV1SupportTicket({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/support/ticket/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить список обращений
   * @returns ResponseData_PagedResponse_TicketResponse OK
   * @throws ApiError
   */
  static getApiAdminV1SupportTicketList({
    statusId,
    categoryId,
    dateFrom,
    dateTo,
    organziationId,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/support/ticket/list",
      query: {
        "statusId": statusId,
        "categoryId": categoryId,
        "dateFrom": dateFrom,
        "dateTo": dateTo,
        "organziationId": organziationId,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить сообщения обращения
   * @returns ResponseData_PagedResponse_MessageResponse OK
   * @throws ApiError
   */
  static getApiAdminV1SupportTicketMessage({
    ticketId,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/support/ticket/message",
      query: {
        "ticketId": ticketId,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить список сообщений личного чата
   * @returns ResponseData_PagedResponse_MessageResponse OK
   * @throws ApiError
   */
  static getApiAdminV1SupportConversationMessage({
    userId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/support/conversation/{userId}/message",
      path: {
        "userId": userId
      }
    });
  }
  /**
   * Получить сообщение
   * @returns ResponseData_MessageResponse OK
   * @throws ApiError
   */
  static getApiAdminV1SupportMessage({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/support/message/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить список личных чатов пользователей
   * @returns ResponseData_PagedResponse_ConversationResponse OK
   * @throws ApiError
   */
  static getApiAdminV1SupportConversation({
    dateFrom,
    dateTo,
    search,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/support/conversation",
      query: {
        "dateFrom": dateFrom,
        "dateTo": dateTo,
        "search": search,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Прочитать сообщения
   * @returns ResponseData_Int32 OK
   * @throws ApiError
   */
  static postApiAdminV1SupportMessageRead({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/support/message/read",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Отправить сообщение
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1SupportMessageSend({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/support/message/send",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Отправить сообщение для обращения
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1SupportTicketMessageSend({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/support/ticket/message/send",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Обращение в работу
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1SupportTicketToWork({
    id
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/support/ticket/{id}/toWork",
      path: {
        "id": id
      }
    });
  }
  /**
   * Обращение в работу
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1SupportTicketClose({
    id
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/support/ticket/{id}/close",
      path: {
        "id": id
      }
    });
  }
};

// src/admin/services/UserService.ts
var UserService = class {
  /**
   * Получить информацию о пользователе
   * @returns ResponseData_UserResponse OK
   * @throws ApiError
   */
  static getApiAdminV1User() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/user"
    });
  }
  /**
   * Обновить данные пользователя
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1User({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить информацию о сертификате
   * @returns ResponseData_Array_UserCertificateResponse OK
   * @throws ApiError
   */
  static postApiAdminV1UserCertificates() {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/user/certificates"
    });
  }
  /**
   * Добавить сертификат
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1UserCertificate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/user/certificate",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Обновить данные 2FA
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1UserTwoFactor({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user/twoFactor",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить пользователей ожидающие подтверждения
   * @returns ResponseData_Array_ActivationPendingUserResponse OK
   * @throws ApiError
   */
  static getApiAdminV1UserPending() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/user/pending"
    });
  }
  /**
   * Активировать пользователя
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1UserActivate({
    id
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user/{id}/activate",
      path: {
        "id": id
      }
    });
  }
  /**
   * Нужны правки по пользователю
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1UserRework({
    id,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user/{id}/rework",
      path: {
        "id": id
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
};
export {
  ApplicationDocumentTypeEnum,
  ApplicationService,
  AuthorizeService,
  CountryEnum,
  CryptoCurrencyEnum,
  DictionaryService,
  EpochEnum,
  HundlerService,
  OrganizationDocumentTypeEnum,
  OrganizationService,
  OrganizationStatusEnum,
  RoleEnum,
  SupportService,
  TicketCategoryEnum,
  TicketStatusEnum,
  UserService,
  UserStatusEnum
};
//# sourceMappingURL=index.js.map